import React, { useEffect, useState } from 'react'

import {
    Divider,
    Grid,
    Button
} from '@mui/material';

import _ from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MoodIcon from '@mui/icons-material/Mood';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

import CustomLayout from 'views/CustomLayout'
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from 'components/Loader';
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from 'constants/routeConstants';
import { GLOBAL_CURRENCY } from 'constants/appConstants';
import ProductList from './ProductList';

let formatCurrency = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: GLOBAL_CURRENCY.code,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2
});

function queryStringToJSON(search) {
    if (!search) return {}
    var qs = search.slice(1);

    var pairs = qs.split('&');
    var result = {};
    pairs.forEach(function (p) {
        var pair = p.split('=');
        var key = pair[0];
        var value = decodeURIComponent(pair[1] || '');

        if (result[key]) {
            if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                result[key].push(value);
            } else {
                result[key] = [result[key], value];
            }
        } else {
            result[key] = value;
        }
    });

    return JSON.parse(JSON.stringify(result));
};

const OrderComplete = ({ breadcrumbs }) => {
    const [loader, setLoader] = useState(true);
    const [order, setOrder] = useState();
    const { search } = useLocation();
    const query = queryStringToJSON(search);
    const { orderid } = query;
    const [orderStatus, setOrderStatus] = useState('Complete');

    const navigate = useNavigate();
    const [productList, setProductList] = useState([]);

    const getOrderStatus = async () => {
        // setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.GET_ORDER_DETAIL, {
            params: {
                transaction_id: orderid
            }
        });
        let { data, response } = res;

        if (response && response.status == 404) {
            setOrderStatus(_.upperCase(response.statusText))
        }
        if (!_.isEmpty(data) && data.data) {
            setOrder(data.data)
            
            localStorage.removeItem("localNotes");

            if (Array.isArray(data?.data?.order_details) && data?.data?.order_details?.length > 0) {
                setOrderStatus(data?.data?.order_details[0]?.
                    delivery_status_type)
            }
            // if (data.data.payment_status == "failed") {
            //     setOrderStatus(_.upperCase(data.data.payment_status))
            // } 
            // if (data.data.payment_status == "expired") {
            //     setOrderStatus(_.upperCase(data.data.payment_status))
            // } 
            // if (data.data.payment_status == "unknown") {
            //     setOrderStatus(_.upperCase(data.data.payment_status))
            // } 
            // if (data.data.payment_status == "pending") {
            //     setOrderStatus(_.upperCase(data.data.payment_status))
            // } 
            // if (data.data.payment_status == "successful") {
            //     setOrderStatus(_.upperCase(data.data.payment_status))
            // } 
            if (_.get(data.data, 'order_details'))
                setProductList(data.data.order_details)
        }
        setLoader(false)
    }

    useEffect(() => {
        if (orderid) {
            getOrderStatus()

        }
    }, [orderid])

    const [currencySymbol, setCurrencySymbol] = useState(""); // NEW state

    const getWebsiteInfo = async () => {
        setLoader(true);
        try {
            const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.WEB_INFO);
            const { data } = res;

            // Update both states from the response
            // setIsWebsiteFunctional(data.status); // adjust if data.data.status
            setCurrencySymbol(data.currency_symbol || "₹"); // default if missing
        } catch (err) {
            console.error(err);
            // setIsWebsiteFunctional(false);
            setCurrencySymbol("₹"); // fallback symbol
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getWebsiteInfo();
    }, []);

    return (
        <CustomLayout>
            <Loader open={loader} />
            <div className="content-container">
                <CustomBreadcrumbs list={breadcrumbs} name={`Order Status - ${orderid}`} />
                <Divider className="divider" />
                <Grid container className="ordercomplete-wrapper main-content-wrapper">
                    <Grid container className="stepper-header">
                        <div className='stepper-header-content'>
                            <span className='inactive' style={{ fontSize: '1.6rem' }}>
                                SHOPPING CART
                            </span>
                            <ArrowForwardIcon style={{ marginBottom: '-3px', fontSize: '1.5rem' }} />
                            <span className='inactive' style={{ fontSize: '1.6rem' }}>
                                CHECKOUT
                            </span>
                            <ArrowForwardIcon style={{ marginBottom: '-3px', fontSize: '1.5rem' }} />
                            <span className='active' style={{ fontSize: '1.6rem', textTransform: "uppercase" }}>
                                {orderStatus}
                            </span>
                        </div>
                    </Grid>
                    <Grid container className="ordercomplete-content" spacing={10}>
                        <Grid item xs={12} sm={12} md={12} lg={8} className="order-container">
                            <Grid container spacing={3}>

                                {!loader && (
                                    orderStatus === "Order Placed" ?
                                        <Grid item xs={12} className='order-title'>
                                            <span className='title-hg'>
                                                Your order has been placed successfully.
                                            </span>
                                            <br />
                                            <div className='icon-wrapper'>
                                                <MoodIcon />
                                            </div>
                                        </Grid>
                                        :
                                        <Grid item xs={12} className='order-title'>
                                            <span className='title-hg-fail'>
                                                {orderStatus}
                                            </span>
                                            <br />
                                            <div className='icon-wrapper-fail'>
                                                <SentimentDissatisfiedIcon />
                                            </div>
                                        </Grid>
                                )}

                                <ProductList order={order} productList={productList} formatCurrency={formatCurrency} currencySymbol={currencySymbol} />
                                {/* {productList.map((product, i) => 
                                        <div className='calc-wrapper'>
                                            <div className='product-detail'>
                                                <div className="image-wrapper">
                                                    <img 
                                                        src={_.get(product, 'product_detail.product_image')} 
                                                        alt={_.get(product, 'product_detail.name')} />
                                                </div>
                                                <div className="detail-wrapper">
                                                    <span className='title'>
                                                        {_.truncate(_.get(product, 'product_detail.name'), { length: 25 })}
                                                    </span>
                                                    <div className='quantity-wrapper'>
                                                        <span className='quantity'>Qty: {product.quantity}</span>
                                                    </div>
                                                    <div className='status-wrapper'>
                                                        <span className='status'>
                                                            {product.delivery_status_type}
                                                        </span>
                                                    </div>
                                                    <div className='status-wrapper'>
                                                        <span className='status'>
                                                            {order.selected_payment_mode.Name}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <span className='description'>
                                                <b>{formatCurrency.format(_.get(product, 'total_price', 0))}</b>
                                            </span>
                                        </div>
                                    )} */}
                                {/* </Grid> */}
                                {_.get(productList[0], 'delivery_status') == 11 ?
                                    <Grid item xs={12} className='order-title'>
                                        <Button
                                            onClick={() => navigate("/cart")}
                                            variant='outlined'>
                                            Go Back To Cart
                                        </Button>
                                    </Grid> : ''}
                            </Grid>
                        </Grid>
                        {!loader ?
                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                <div className='ordercomplete-summary'>
                                    <span className='title'>
                                        ORDER DETAIL
                                    </span>
                                    {order?.total_price > 0 &&
                                        <>
                                            <Divider className="divider" />
                                            <div className='calc-wrapper'>
                                                <span className='description'>
                                                    Subtotal
                                                </span>
                                                <span className='description'>
                                                    {/* <b>{GLOBAL_CURRENCY.symbol}{_.get(order, 'total_price')}</b> */}
                                                    <b>{currencySymbol} {(_.get(order, 'total_price', 0))}</b>
                                                </span>
                                            </div>
                                        </>
                                    }
                                    {order?.voucher_discount > 0 &&
                                        <>
                                            <Divider className='divider' />
                                            <div className='calc-wrapper'>
                                                <span className='description'>
                                                    Coupon
                                                </span>
                                                <span className='description'>
                                                    <b>{currencySymbol} {(_.get(order, 'voucher_discount', 0))}</b>
                                                </span>
                                            </div>
                                        </>
                                    }{order?.shipping_charge > 0 &&
                                        <>
                                            <Divider className='divider' />
                                            <div className='calc-wrapper'>
                                                <span className='description'>
                                                    Shipping
                                                </span>
                                                <span className='description'>
                                                    <b>{currencySymbol} {(_.get(order, 'shipping_charge', 0))}</b>
                                                </span>
                                            </div>
                                        </>}
                                    <Divider className='divider' />
                                    <div className='calc-wrapper'>
                                        <span className='description'>
                                            Total
                                        </span>
                                        <span style={{ fontSize: '1.5rem' }} className='total-amt'>
                                            <b>{currencySymbol} {(_.get(order, 'final_price', 0))}</b>
                                        </span>
                                    </div>
                                    <div className='button-wrapper'>
                                        <Button
                                            variant="contained"
                                            onClick={() => navigate('/')}
                                        >
                                            Back to Shopping
                                        </Button>
                                    </div>
                                </div>
                            </Grid>
                            : ''}
                    </Grid>
                </Grid>
            </div>
        </CustomLayout>
    )
}
// 
export default OrderComplete